module.exports = __webpack_public_path__ + "img/返回@2x.fe7bdffb.png";